export default function builMediaMarkUp(item, config, classes) {
    // Use native lazy loading instead of lazysizes
    const lazyAttributes = `loading="lazy" decoding="async" data-fade-in`;
    const imageClass = classes ? classes : `w-full block ${config.imageFill}`;

    // Fail safe image placeholder
    let mediaMarkUp = `
        <img 
            src="${config.imagePlaceholderPath}" 
            alt="${item.title}"  
            class="${imageClass}" 
            ${lazyAttributes}
        />
    `;

    if (item.image) {
        mediaMarkUp = `
            <img 
                src="${item.image}" 
                alt="${item.title}" 
                class="${imageClass}" 
                ${lazyAttributes}
            />
        `;
    }

    if (item.animatedAsset && config.showAnimatedMedia == "true") {
        const animatedMediaObj = item.animatedAsset;
        const assetLink = animatedMediaObj.link;
        const showControls = animatedMediaObj.showControls ? animatedMediaObj.showControls : "false";
        const isLoop = animatedMediaObj.isLoop ? animatedMediaObj.isLoop : "false";
        const isBounce = animatedMediaObj.isBounce ? animatedMediaObj.isBounce : "false";
        const isAutoplay = animatedMediaObj.isAutoplay ? animatedMediaObj.isAutoplay : "false";
        const animationSpeed = animatedMediaObj.animationSpeed ? animatedMediaObj.animationSpeed : "1";

        mediaMarkUp = `
            <lottie-player
                x-data="animatedMedia({
                    showControls: ${showControls},
                    isLoop: ${isLoop},
                    isBounce: ${isBounce},
                    isAutoplay: ${isAutoplay},
                    animationSpeed: ${animationSpeed},
                })"
                x-ref="lottie"
                class="cursor-pointer"
                src="${assetLink}"
                x-intersect:enter.half="isMobile ? enterView : null"
                x-intersect:leave="isMobile ? exitView : null"
                :mode="isBounce ? 'bounce' : 'normal'"
                :speed="animationSpeed"
                :controls="showControls ? '' : null"
                :autoplay="isAutoplay && !isMobile ? '' : null"
                :hover="isMobile || isAutoplay ? null : ''"
                :loop="isLoop ? '' : null"
            >
            </lottie-player>
        `;
    }

    return mediaMarkUp;
}
